import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { VerifyOrgLlmConnectionResponse } from "../OrgLlmProviderRecord";

import { refreshAfterConnectionChange } from "./useOrgLlmConnectionMutations";

interface VerifyOrgLlmConnectionVariables {
  orgId: string;
  connectionId: string;
  /** The provider's model id to call; omitted uses the first model on the org's list on this connection. */
  testModelId?: string | null;
}

/**
 * Call a model on one of the org's connections and record the outcome on the
 * connection's status (premium orgs, admins). A failed call resolves with
 * `error` set rather than rejecting.
 */
export function useVerifyOrgLlmConnection() {
  const { orgService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<
    VerifyOrgLlmConnectionResponse,
    Error,
    VerifyOrgLlmConnectionVariables
  >({
    mutationFn: ({ orgId, connectionId, testModelId }) =>
      orgService.verifyOrgLlmConnection(orgId, connectionId, testModelId),
    onSuccess: (_response, { orgId }) =>
      refreshAfterConnectionChange(queryClient, orgId),
  });
}
